export default "__VITE_ASSET__BxqCfYF8__"